import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

interface Props {
  onRemove: () => Promise<boolean>;
}

const GroupUserAttributesRemove = ({ onRemove }: Props) => {
  const { messages } = useReduxState();

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonStyle={{ whiteSpace: 'nowrap' }}
      buttonText={messages.commonRemove}
      category="danger"
      confirmText={messages.groupsUserAttributesRemoveConfirm}
      confirmTitle={messages.groupsUserAttributesRemove}
      onConfirm={onRemove}
      successMessage={messages.groupsUserAttributesRemoveSuccess}
    />
  );
};

export default GroupUserAttributesRemove;
